import React from 'react'
import Gifting_Products_Card from '../Cards/Gifting_Products_Card';
import ProductCard from '../Cards/ProductCard';

const Gifting_Products_Container = () => {
  return (
    <div>
 <div className='w-full px-1 lg:px-2 py-2 lg:py-4'>
        {/* <h1 className='text-3xl  font-bold py-2 lg:ml-4 mb-4'>Top Deals</h1> */}
        <div className='grid grid-cols-2 lg:grid-cols-4 md:grid-cols-4 gap-1 md:gap-2 lg:gap-4'>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
     <Gifting_Products_Card/>
        </div>

    </div>
    </div>
  )
}

export default Gifting_Products_Container